import { style } from '@vanilla-extract/css'

const screenContainer = style({
  backgroundColor: '#F2F1EF',
  fontFamily: 'Inter Variable, sans-serif',
  color: '#252525',
  width: '100%',
  minHeight: 'calc(100dvh - 60px)',
  padding: '40px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

const pageContainer = style({
  width: '100%',
  maxWidth: '540px',
  margin: '0 auto',
  '@media': {
    '(min-width: 960px)': {
      width: '440px',
    },
  },
})

export const styles = {
  screenContainer,
  pageContainer,
}
